import React, { useState, useEffect } from "react";
import { isEmpty } from "../../../../../custom_utilities/custom_useful_functions";

import axios from "axios";

import { connect } from "react-redux";
import { url_146 } from "../../../../../custom_utilities/api_services";
import uiActions from "../../../../../redux/ui/action";
import { useHistory } from "react-router-dom";
import userMockTestsAction from "../../../../../redux/mock_test_exercise/action";

const MockTestAdvance = (props) => {
  let {
    setMockTestData,
    startLoading,
    finishLoading,
    userPreference,
    setMockTestsResultData,
  } = props;

  const [state, setState] = useState({
    mockAdvanceTestPaperList: [],
    advanceFlag: "jee-advance",
  });

  let history = useHistory();

  let { targetDetails } = userPreference;

  useEffect(() => {
    getAdvancedTest();
  }, [state.advanceFlag]);

  const getAdvancedTest = async () => {
    startLoading();
    try {
      const response = await axios.post(url_146);
      if (response.data.status === 200) {
        finishLoading();
        if (targetDetails[0].target_id == "2") {
          let filteredArray = [];
          for (let i = 0; i < response.data.data.length; i++) {
            if (
              state.advanceFlag == "jee-advance" &&
              response.data.data[i].format.toLowerCase().includes("adv")
            ) {
              filteredArray[i] = response.data.data[i];
            }
          }
          setState((preState) => ({
            ...preState,
            mockAdvanceTestPaperList: filteredArray,
          }));
        }
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const onHandleTakeTest = (testData) => {
    setMockTestData(testData);
    history.push("/mock_test_component");
  };

  const onHandleSummary = (testData) => {
    setMockTestsResultData(testData);
    history.push("/mock_test_summary");
  };

  const onHandleTakeTest2 = (testData) => {
    setMockTestData(testData);
    history.push("/mock_practice_test");
  };

  return (
    <>
      <div className="mockTestWrapper">
        {!isEmpty(state.mockAdvanceTestPaperList)
          ? state.mockAdvanceTestPaperList.length
            ? state.mockAdvanceTestPaperList.map((element, index) => {
                return (
                  <div key={index} className="mockTestBox">
                    <div className="mockTestNameType">
                      <div className="mockTestName">
                        {element.icon ? (
                          <img src={element.icon} alt="img" />
                        ) : null}
                        <span>{element.paper_name}</span>
                      </div>
                      <div className="examDate">
                        Exam Date : {element.to_be_held_on}
                      </div>
                    </div>

                    <div className="mockTestPara">
                      <p>{element.format}</p>
                    </div>

                    <div className="attemBtn">
                      {!element.is_attempted ? (
                        <button
                          className="attempt"
                          onClick={() => onHandleTakeTest(element)}
                        >
                          Take Test
                        </button>
                      ) : (
                        <>
                          <button
                            className="practice"
                            onClick={() => onHandleSummary(element)}
                          >
                            Summary
                          </button>

                          <button
                            className="practice"
                            onClick={() => onHandleTakeTest(element)}
                          >
                            Try Again
                          </button>
                        </>
                      )}
                      <button
                        className="practice"
                        onClick={() => onHandleTakeTest2(element)}
                      >
                        Practice
                      </button>
                    </div>
                  </div>
                );
              })
            : null
          : null}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

const mapDipatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setMockTestData: (payload) => {
      dispatch(userMockTestsAction.setMockTestsData(payload));
    },

    setMockTestsResultData: (payload) => {
      dispatch(userMockTestsAction.setMockTestsResultData(payload));
    },
  };
};

export default connect(mapStateToProps, mapDipatchToProps)(MockTestAdvance);
